//This controls our http requests, it will auto-inject the bearer token in all calls and will throw the user to /login if any are unauthorised
import axios from "axios";
import qs from "qs";
import { showToast } from "../../redux/slices/Toasts";
import { store } from "../../redux/store";
import { logout } from "./authService";

const responseTimeout = 5 * 60 * 1000; // set response timeout to 5 minutes
const TIMEOUT_CODE = "ECONNABORTED";
const axiosPort = 9081;

export function Initialise(baseUrl?: string, isWebWorker: boolean = false) {
  // let request = axiosRequestInterceptor;
  // let response = axiosResponseInterceptor;
  axios.defaults.baseURL = baseUrl ?? window.location.protocol + "//" + window.location.hostname + ":" + axiosPort + "/";
  axios.defaults.headers.common["Content-Encoding"] = "gzip";
  // axios.defaults.baseURL = "http://" + window.location.hostname + ":9081/";
  axios.defaults.paramsSerializer = function (params) {
    return qs.stringify(params, { indices: false }); // param=value1&param=value2
  }

  // Interceptors
  // Add a request interceptor to add the bearer token header
  axios.interceptors.request.use(function (config) {
    if (!isWebWorker && localStorage.getItem("authData") == null) {
      axios.defaults.headers.Authorization = "";
      config.headers.Authorization = "";
    }
    // Make connection timeout 1 minute longer than response timeout so we will always trigger response timeout to display a toast.
    // The connection timeout can get triggered for other random reasons like errors in react (because a request gets "cancelled"), so we
    // don't want to use this timeout to know if we should display a toast, we just want to use the response timeout. That way we know for sure
    // it was actually caused due to a timeout
    config.cancelToken = new axios.CancelToken((cancel) => setTimeout(cancel, responseTimeout + (1 * 60 * 1000)));
    config.timeout = responseTimeout;
    // Do something before request is sent
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // Add a response interceptor to check if unauthorised then send to login page instead
  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    console.log("Axios received error: ");
    console.log(error);
    if (isWebWorker) return Promise.reject(error);

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401) {
      logout(true, true);
    } else {
      // isCancel can get triggered for any number of reasons, including errors in React causing the compiled javascript to fail
      // for example, Toasts didn't have a unique key and this was causing a network call to cancel, triggering this. Therefore, don't do anything
      // when isCancel is triggered.
      if (!axios.isCancel(error)) {
        if (error.code === TIMEOUT_CODE) { // For handling timeout
          //store.dispatch(showToast({ value: [`Error: Request timed out!`]}));
          console.log("Request timed out!")
        } else if (error.response && error.response.status && error.response.data) { // For handling any non-200 errors returned from backend.
            if (error.response.status === 400 && error.response.data.detail != undefined && error.response.data.detail.includes("[{")) {
              const errorMessageObject = JSON.parse(error.response.data.detail);
              let errorMessages: any[] = [];
              errorMessageObject.forEach((err: any) => {
                errorMessages.push(err.message);
              });
              store.dispatch(showToast({ value: errorMessages}));
            } else {
              //store.dispatch(showToast({ value: [`Error code ${error.response.status}: ${error.response.data}`]}));
              store.dispatch(showToast({ value: [`Error code ${error.response.status}: ${typeof (error.response.data) === "object" ? (error.response.data.Message ?? error.response.data.message ?? "Unknown error occurred") : error.response.data}`] }));
            }
          } else if (error.code && error.message) { // Fallback in case the previous case didn't catch exactly what error it was
          //store.dispatch(showToast({ value: [`Error ${error.code}: ${error.message}`]}));
          console.log(`Error ${error.code}: ${error.message}`);
        }
      }
    }
    return Promise.reject(error);
  });
}

export function AddBearerToken(token: string | null) {
  axios.defaults.headers.Authorization = "bearer " + token;
}
